module.exports = __webpack_public_path__ + "static/media/notification_icon.6864fdb6.svg";